module.exports = __webpack_public_path__ + "ff5df6697ccf17e8e5a3923514df49a8.pdf";